const register = {
  loginCredentials: "ログイン認証情報", // translated
  companyInformation: "企業情報", // translated
  contactDetails: "連絡先の詳細", // translated
  businessName: "商号", // translated
  businessAddress: "職場の住所", // translated
  registrationCode: "登録コード", // translated
  websiteUrl: "ウェブサイトのURL", // translated
  mobilePhone: "携帯電話", // translated
  regionStateProvince: "地域/州/県", // translated
  legalTitle: "法的所有権", // translated
  city: "市", // translated
  postalCode: "郵便番号", // translated
  registrationSuccess: "登録完了。", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "ホームページにリダイレクトされるので、しばらくお待ちください。", // translated
  businessRegistrationNumber: "Business Registration Number",
};


export default register;
